import { render, staticRenderFns } from "./CoTwoClap.vue?vue&type=template&id=2758d7c6&scoped=true&"
import script from "./CoTwoClap.vue?vue&type=script&lang=js&"
export * from "./CoTwoClap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2758d7c6",
  null
  
)

export default component.exports